import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { GridOptions } from 'ag-grid-community';
import { AlertService } from 'src/app/shared-services/alert.service';
import { UserService } from 'src/app/shared-services/userservice.service';

@Component({
    selector: 'app-notifiPrefer',
    templateUrl: './notifiPrefer.component.html',
    styleUrls: ['./notifiPrefer.component.scss']
  })
  export class NotifiPreferrComponent implements OnInit {
    gridApi;
    paginationPageSize;
    paginationPageSize1;
    domLayout;
    public isDateRange:boolean;
    public DateFrom ="";
  public DateTo ="";
  public dateValue ="all";
  public loading = true;
  public caregiver:boolean;
  public recruiter:boolean;
  public phoneNumber;
  public note:boolean;

  public changesDone:boolean;
  options = {                             /** auto close error, success messages after some time & if we change route */
  autoClose: true,
  keepAfterRouteChange: false
};
 
     rowData =[];
     initialData =[];
    ngOnInit(): void {
     // localStorage.getItem('phoneNumber');
      
      // this.userService.UserProfile().subscribe((res:any) =>{
      //   this.phoneNumber = res.body.phoneNumber;
      //   if(this.phoneNumber ==null || this.phoneNumber == ""){
      //     this.note = true;
      //   }
      //   else{
      //     this.note = false;
      //   }
      // })
        this.userService.getNotificationPref().subscribe((res:any)=>{
          console.log("userObject", res);
          this.rowData = res.notificationPreferBean;
          if(localStorage.getItem('phoneNumber') ==null || localStorage.getItem('phoneNumber') == ""){
            this.note = true;
            }
            else{
              this.note = false;
            }
          sessionStorage.setItem("initialValues", JSON.stringify(this.rowData));
        //  this.initialData = res.notificationPreferBean;
          this.loading = false;
        })
       
//           const utcTimestamp = "2021-06-22T12:03:43.000+0000";
// const date = new Date(utcTimestamp);

// // Automatically convert to the user's local timezone
// const localTime = this.datePipe.transform(date, 'yyyy-MM-dd HH:mm:ss');
    }
    constructor(
        private userService:UserService,
        public alertService:AlertService,
      ){
        this.paginationPageSize =10;
        this.paginationPageSize1 =10;
        this.domLayout = 'autoHeight';
       
      }
      columnDefs = [{headerName:"Functionality Name", field: "funtionalityNames", sortable:true, unSortIcon: true, filter:true,resizable: true},
      {headerName:"SMS", field: "mobileNotify", sortable: true, unSortIcon: true, filter:true, resizable: true, cellRenderer: (params) => {
        const input = document.createElement("input");
        input.type = "checkbox";
        input.checked = params.value || false;
        // ✅ Disable checkbox if phoneNumber is null or empty
    if (this.note) {
      input.disabled = true;
    }
        input.addEventListener("change", (e) => {
          const target = e.target as HTMLInputElement; // 👈 cast to HTMLInputElement
          params.node.setDataValue("mobileNotify", target.checked);
        });
        return input;
      },}, 
      {headerName:"EMAIL", field: "emailNotify", sortable: true, unSortIcon: true, filter:true, resizable: true,
      cellRenderer: (params) => {
        const input = document.createElement("input");
        input.type = "checkbox";
        input.checked = params.value || false;
        input.addEventListener("change", (e) => {
          const target = e.target as HTMLInputElement; // 👈 cast to HTMLInputElement
          params.node.setDataValue("emailNotify", target.checked);
        });
        return input;
      }},
      ]
      gridOptions: GridOptions = {
        defaultColDef: {
          // sortable: true,
          // filter: true,
          // resizable: true,
          menuTabs: ['filterMenuTab'], // Show only the filter menu
        },
        icons: {
          menu: '<i class="fa fa-search"></i>', // Replace menu icon with a search icon
        },
        onRowClicked: (event) => {
          console.log("Clicked row:", event.data);
          const storedValues = sessionStorage.getItem("initialValues");
          if (storedValues) {
            this.initialData = JSON.parse(storedValues);
          }
          console.log(this.rowData);
          console.log(this.initialData);
          this.changesDone = JSON.stringify(this.rowData) !== JSON.stringify(this.initialData);
          console.log(this.changesDone);
        }
      }
        onGridReady(params) {  /** for caregiver table */
          
          // params.api.sizeColumnsToFit();
          if(window.matchMedia("(min-width: 1260px)").matches){
           params.api.sizeColumnsToFit();
         }
           window.addEventListener("resize", function () {
             setTimeout(function () {
               if(window.matchMedia("(min-width: 1260px)").matches){
               params.api.sizeColumnsToFit();
             }
             });
           });
         
         this.gridApi = params;
         this.gridApi.api.setColumnDefs(this.columnDefs);
         this.gridApi.api.setRowData(this.rowData); 
         //this.autoSizeAll();
        
        // this.gridApi.setDomLayout('autoHeight');
         //document.getElementById('#myGrid').style.height = '';
       }
      
    
      onRowSelected(event) { /** for row selection of home page documents  */
      //console.log(event);
      const sortModel = event.api.getSortModel();
      console.log(sortModel);
      
      let i = event.rowIndex;
      if(event.api.filterManager.allAdvancedFilters.size>0 || sortModel !=null){
        i= event.node.id;
      }
     
    
    }

    saveChanges(){
      this.userService.saveChanges(this.rowData).subscribe((nextresult:any)=>{
console.log(nextresult);
this.alertService.success('Success! Your details have been updated', this.options);
if(nextresult.responseMessage == "Notification preferences updated successfully"){
  this.userService.getNotificationPref().subscribe((res:any)=>{
    this.rowData = res.notificationPreferBean;
    sessionStorage.setItem("initialValues", JSON.stringify(this.rowData));
    this.changesDone = false;
  //  this.initialData = res.notificationPreferBean;
  })
}
      },
      err =>{

      })
    }
  }
